module.exports = {"providers":[],"authenticationFlowType":"USER_PASSWORD_AUTH"};